// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__0Me1w","main":"SecOne_main__KCsa6","ul":"SecOne_ul__Xwbqd","active":"SecOne_active__kg+Az"};